import React, { useState, useEffect } from "react"

import { css, logTool } from "@jsUtils"
import { joinNewLines } from "@jsUtils/contentful"
import { CONTENT, CONSTANTS } from "@data"

import { Eyebrow, GridLines, Headline, CirclesBurstSet, HubSpotForm } from "@shared"

import { PageSection } from "@components/sections"

import Styles from "./subscribe.module.scss"

const { SUBSCRIBE } = CONTENT
const { headline, subhead, body, error } = SUBSCRIBE
const { MISC, SUBMIT } = CONSTANTS
const { ANALYTICS } = MISC

const log = logTool()

/**
 * Subscribe CRM Module on home page
 * @param {object} props - React props
 */
const Subscribe = props => {
  const { color, theme } = props

  const [ready, setReady] = useState(false)

  const [stat, setSuccess] = useState(SUBMIT.IDLE)

  useEffect(() => {
    log("Subscribe stat state:", stat)
  }, [stat])

  return (
    <PageSection
      theme={theme}
      className={css(Styles.subcribe, ready && Styles.ready)}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <CirclesBurstSet ready={ready} />
      <div className={Styles.wrapper}>
        <div
          className={css(
            Styles.content,
            stat === SUBMIT.SUCCESS && ANALYTICS.SUBSCRIBE_SUCCES,
            stat === SUBMIT.FAIL && ANALYTICS.SUBSCRIBE_FAIL
          )}
        >
          <div className={Styles.contentWrapper}>
            <Eyebrow color={color} className={Styles.eyebrow}>
              Stay in the Loop
            </Eyebrow>
            <div className={Styles.mainContent}>
              <Headline size={2} className={Styles.headline}>
                {/* eslint-disable-next-line react/no-danger */}
                <span dangerouslySetInnerHTML={{ __html: joinNewLines(headline) }} />
              </Headline>
              {subhead && (
                <Headline size={2} color={color} className={Styles.headlinePrimary}>
                  {subhead}
                </Headline>
              )}
              <p className={Styles.body}>{stat === SUBMIT.FAIL ? error : body}</p>
              <div className={Styles.subscribeFormModule}>
                <HubSpotForm
                  id="subscription-form-module"
                  portalId="20465501"
                  formId="ce86ff4b-80f7-4187-800b-de1c3c178b0b"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export default Subscribe
